import styled from '@emotion/styled';
import React from 'react';

export interface IProps {
  children: React.ReactNode;
  [key: string]: any;
}

const Host = styled.tbody``;

export const Tbody = ({ children, ...rest }: IProps) => {
  return <Host {...rest}>{children}</Host>;
};
